import { ProductForm } from '@/modules/product/add-product';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
  step: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/product/add-product/')({
  validateSearch: searchSchema,
  component: AddProductPage,
});

function AddProductPage() {
  const { id: productId } = useSearch({
    from: '/dashboard/product/add-product/',
  });

  return <ProductForm initialProductId={productId || null} />;
}
